import React, { useState, useEffect } from 'react';
import api from '../services/api';

const KLEUREN = ['#2563eb', '#059669', '#d97706', '#7c3aed', '#db2777', '#0891b2'];
const MAANDEN = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
const DAGL = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
const p2 = (n) => String(n).padStart(2, '0');

export default function ProjectMaandOverzicht({ onOpen }) {
  const nu = new Date();
  const [jaar, setJaar] = useState(nu.getFullYear());
  const [maand, setMaand] = useState(nu.getMonth());
  const [projecten, setProjecten] = useState([]);
  const [laden, setLaden] = useState(true);
  const [fout, setFout] = useState('');

  const n = new Date(jaar, maand + 1, 0).getDate();
  const pre = jaar + '-' + p2(maand + 1) + '-';
  const ms = pre + '01';
  const me = pre + p2(n);
  const vandaag = nu.getFullYear() + '-' + p2(nu.getMonth() + 1) + '-' + p2(nu.getDate());

  useEffect(() => {
    let actief = true;
    setLaden(true); setFout('');
    api.get('/planning/project-maand', { params: { start: ms, eind: me } })
      .then(r => { if (actief) setProjecten(r.data.projecten || []); })
      .catch(e => { if (actief) setFout(e.response?.data?.message || e.message); })
      .finally(() => { if (actief) setLaden(false); });
    return () => { actief = false; };
  }, [ms, me]);

  const stap = (d) => { const x = new Date(jaar, maand + d, 1); setJaar(x.getFullYear()); setMaand(x.getMonth()); };

  // afdelingskleuren
  const afdNaam = {};
  projecten.forEach(p => {
    if (p.afdeling_id) afdNaam[p.afdeling_id] = p.afdeling_naam;
    p.dagen.forEach(d => { if (d.afdeling_id) afdNaam[d.afdeling_id] = d.afdeling_naam; });
  });
  const afdIds = Object.keys(afdNaam).map(Number).sort((a, b) => a - b);
  const kleur = (id) => KLEUREN[Math.max(0, afdIds.indexOf(Number(id))) % KLEUREN.length];

  const info = projecten.map(p => {
    const s = p.start_datum || p.eind_datum;
    const e = p.eind_datum || p.start_datum;
    const inMaand = (s && s <= me && e >= ms) || p.dagen.length > 0;
    return { ...p, s, e, inMaand, over: !!(e && e < vandaag) };
  });
  const lopend = info.filter(p => p.inMaand);
  const overDatum = info.filter(p => !p.inMaand && p.over);
  const zonderDatum = info.filter(p => !p.inMaand && !p.s);

  const dagen = Array.from({ length: n }, (_, i) => i + 1);
  const cols = 'repeat(' + n + ', minmax(16px, 1fr))';
  const rij = { display: 'grid', gridTemplateColumns: '230px 1fr', alignItems: 'center', borderBottom: '1px solid #f1f5f9' };
  const dagBg = (d) => {
    const ds = pre + p2(d);
    if (ds === vandaag) return '#dbeafe';
    const wd = new Date(jaar, maand, d).getDay();
    return (wd === 0 || wd === 6) ? '#f3f4f6' : 'transparent';
  };
  const knop = { padding: '4px 10px', border: '1px solid #d1d5db', borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 13 };

  return (
    <div style={{ background: 'white', borderRadius: 8, padding: 14, marginBottom: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
        <button style={knop} onClick={() => stap(-1)}>&larr;</button>
        <strong style={{ fontSize: 15, minWidth: 130, textAlign: 'center' }}>{MAANDEN[maand]} {jaar}</strong>
        <button style={knop} onClick={() => stap(1)}>&rarr;</button>
        <button style={knop} onClick={() => { setJaar(nu.getFullYear()); setMaand(nu.getMonth()); }}>Deze maand</button>
        <span style={{ flex: 1 }} />
        {afdIds.map(id => (
          <span key={id} style={{ fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 10, height: 10, borderRadius: 2, background: kleur(id) }} />{afdNaam[id] || ('afd ' + id)}
          </span>
        ))}
      </div>

      {fout && <div style={{ color: '#b91c1c', fontSize: 13 }}>Fout: {fout}</div>}
      {laden && <div style={{ color: '#6b7280', fontSize: 13 }}>Laden...</div>}

      {!laden && !fout && (
        <div style={{ overflowX: 'auto' }}>
          <div style={{ minWidth: 760 }}>
            <div style={{ ...rij, borderBottom: '2px solid #e5e7eb' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7280' }}>Project ({lopend.length})</div>
              <div style={{ display: 'grid', gridTemplateColumns: cols }}>
                {dagen.map(d => (
                  <div key={d} style={{ textAlign: 'center', fontSize: 10, color: '#6b7280', background: dagBg(d), padding: '2px 0' }}>
                    <div>{DAGL[new Date(jaar, maand, d).getDay()]}</div>
                    <div style={{ fontWeight: 700, color: '#111827' }}>{d}</div>
                  </div>
                ))}
              </div>
            </div>

            {lopend.length === 0 && <div style={{ padding: 12, fontSize: 13, color: '#6b7280' }}>Geen projecten in deze maand.</div>}

            {lopend.map(p => {
              const sIdx = p.s ? (p.s < ms ? 1 : parseInt(p.s.slice(8), 10)) : null;
              const eIdx = p.e ? (p.e > me ? n : parseInt(p.e.slice(8), 10)) : null;
              const heeftBalk = p.s && p.s <= me && p.e >= ms;
              const perDag = {};
              p.dagen.forEach(d => { (perDag[d.datum] = perDag[d.datum] || []).push(d); });
              const eerste = Object.keys(perDag).sort()[0] || (p.s && p.s > ms ? p.s : ms);
              return (
                <div key={p.id} style={rij}>
                  <div onClick={() => onOpen && onOpen(p.id, eerste)} title={p.naam + ' - klik om te openen'}
                    style={{ cursor: 'pointer', padding: '5px 8px 5px 0', minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#1f2937', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.naam}</div>
                    <div style={{ fontSize: 10, color: '#6b7280' }}>
                      {p.afdeling_naam || '-'} &middot; {p.wo_gepland}/{p.wo_totaal} gepland
                      {p.over && <span style={{ color: '#b91c1c', fontWeight: 700 }}> &middot; over datum</span>}
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: cols, height: 30 }}>
                    {dagen.map(d => <div key={'b' + d} style={{ gridColumn: d, gridRow: 1, background: dagBg(d) }} />)}
                    {heeftBalk && (
                      <div style={{ gridColumn: sIdx + ' / ' + (eIdx + 1), gridRow: 1, alignSelf: 'center', height: 14, borderRadius: 7,
                                    background: p.over ? '#fee2e2' : '#e0e7ff', border: '1px solid ' + (p.over ? '#fca5a5' : '#c7d2fe') }} />
                    )}
                    {Object.keys(perDag).map(ds => {
                      const d = parseInt(ds.slice(8), 10);
                      const lijst = perDag[ds];
                      return (
                        <div key={ds} onClick={() => onOpen && onOpen(p.id, ds)}
                          title={ds + ': ' + lijst.map(x => (x.afdeling_naam || '?') + ' ' + x.n + ' wo').join(', ')}
                          style={{ gridColumn: d, gridRow: 1, alignSelf: 'center', height: 20, margin: '0 1px', borderRadius: 3,
                                   overflow: 'hidden', display: 'flex', flexDirection: 'column', cursor: 'pointer', zIndex: 1 }}>
                          {lijst.map((x, i) => <div key={i} style={{ flex: 1, background: kleur(x.afdeling_id) }} />)}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {!laden && !fout && overDatum.length > 0 && (
        <div style={{ marginTop: 12, fontSize: 12 }}>
          <strong style={{ color: '#b91c1c' }}>Over datum, nog actief ({overDatum.length}):</strong>{' '}
          {overDatum.map((p, i) => (
            <span key={p.id} onClick={() => onOpen && onOpen(p.id, null)} style={{ cursor: 'pointer', textDecoration: 'underline', color: '#374151' }}>
              {p.naam} (eind {p.e}){i < overDatum.length - 1 ? ', ' : ''}
            </span>
          ))}
        </div>
      )}
      {!laden && !fout && zonderDatum.length > 0 && (
        <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280' }}>
          <strong>Zonder datum ({zonderDatum.length}):</strong> {zonderDatum.map(p => p.naam).join(', ')}
        </div>
      )}
    </div>
  );
}
